import {useMemo, useEffect, useState} from 'react';
import {AppBar, Box, Button, Grid, Slider, TextField, ThemeProvider, Typography, useMediaQuery} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import QRCode from "react-qr-code";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [phone, setPhone] = useState('');
  const [body, setBody] = useState('');
  const [link, setLink] = useState('');
  const [htmlLink, setHtmlLink] = useState('');
  const [size, setSize] = useState(128);
  const [linkText, setLinkText] = useState('');

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: prefersDarkMode ? 'dark' : 'light',
        },
      }),
    [prefersDarkMode],
  );

  useEffect(() => {
    const updateLink = () => {
      const _link = `sms://${phone}&body=${encodeURI(body)}`;
      setLink(_link);
      setHtmlLink(`<a href="${_link}">${linkText}</a>`);
    }
    updateLink();
  }, [phone, body, linkText])

  const updatePhone = (e) => {
    setPhone(e.target.value)
  };

  const updateBody = (e) => {
    setBody(e.target.value)
  };

  const copyLink = () => {
    navigator.clipboard.writeText(link);
  }

  const copyHtmlLink = () => {
    navigator.clipboard.writeText(htmlLink);
  }

  const updateLinkText = (e) => {
    setLinkText(e.target.value);
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1, backgroundColor: 'background.default', height: '100vh' }}>
        <Grid container direction="column" alignItems="center" sx={{ pt: 2 }}>
          <Grid item sx={{ pt: 2 }}>
            <TextField label="Phone" variant="outlined" value={phone} onChange={updatePhone} />
          </Grid>
          <Grid item sx={{ pt: 2 }}>
            <TextField label="Body" value={body} variant="outlined" multiline rows={3} onChange={updateBody} />
          </Grid>
          <Grid item sx={{ pt: 2 }}>
              
          </Grid>
          <Grid item sx={{ pt: 2 }} >
            <Grid container direction="row" justifyContent="center" alignItems="center">
              <Grid item sx={{ pr: 1 }}>
                <TextField disabled label="SMS Link" variant="outlined" value={link} size="small" />
              </Grid>
              <Grid item>
                <Button startIcon={<ContentCopyIcon />} variant="outlined" onClick={copyLink}>
                    Copy
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Box sx={{ width: 300, pt: 2 }}>
              <Slider
                value={size}
                step={null}
                min={128}
                max={1024}
                onChange={(e) => setSize(e.target.value)}
                marks={[
                  {value: 128, label: '128'},
                  {value: 256, label: '256'},
                  {value: 384, label: '384'},
                  {value: 512, label: '512'},
                  {value: 768, label: '768'},
                  {value: 1024, label: '1024'}
                ]}
              />
            </Box>
          </Grid>
          <Grid item sx={{ pt: 2 }}>
            <QRCode value={link} size={size} />
          </Grid>
          <Typography variant="h6" color="primary">Create a HTML Link</Typography>
          <Grid item sx={{ pt: 2 }}>
            <TextField label="Link Text" value={linkText} variant="outlined" onChange={updateLinkText} />
          </Grid>
          <Grid item sx={{ pt: 2 }} >
            <Grid container direction="row" justifyContent="center" alignItems="center">
              <Grid item sx={{ pr: 1 }}>
                <TextField disabled label="Link" variant="outlined" value={htmlLink} size="small" />
              </Grid>
              <Grid item>
                <Button startIcon={<ContentCopyIcon />} variant="outlined" onClick={copyHtmlLink}>
                    Copy
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ pt: 2 }}>
            <a href={link}>{linkText}</a>
          </Grid>
        </Grid>
        <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
          <Button href="https://www.leadsigma.com" color="inherit">
            <Typography>LeadSigma Labs 🚀🚀🚀</Typography>
          </Button>
        </AppBar>
      </Box>
    </ThemeProvider>
  );
}

export default App;
